export const getLinkedCardsErrorHandler = (err) => {
  const {errorCode} = err
  if (errorCode) {
    throw formatError(err, `perksgo.graph.errors.card.getLinkedCards.${errorCode}`)
  }
  throw err
}

export const removeLinkedCardErrorHandler = (err) => {
  // @todo - replace with correct error handling in the future
  const {errorCode} = err
  if (errorCode) {
    throw formatError(err, `perksgo.graph.errors.card.removeLinkedCard.${errorCode}`)
  }
  throw err
}

const formatError = (err, str) => {
  err.message = str
  return err
}
